// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2GHh3","productName":"Table_productName__pE4s3"};